<template>

<div>

    <div class="row justify-content-center mt-5 mb-5">
        <div class="col-md-10 text-center">
            <p class="sub-title text-center">Вашето предложение за</p>
            <h2 class="title text-orange">
                Идеен проект
            </h2>                        
        </div>                    
    </div>

    <div class="row">
        <div class="col-12">
            <h4 class="mb-0">Снимка на корица</h4>
            <p>Това е снимката, която ще се показва първа в страницата на проекта.</p>    
            <div class="cover-wrap">
                <img-field :model='imgModel' :f='"cover"' ref='cover' 
                    :options='coverOptions' 
                    v-on:image-set='uploadImage("cover")'></img-field>  
            </div>
        </div>
    </div>

    <div class="row d-flex justify-content-center">
        <div class="col-10">
            <div class="page-header-info page-header-concept page-header-upload shadow-lg pl-4 pr-4 pt-4 mb-5 text-center">
                <div class="form-group form-name">
                    <label for="c-title">
                        <span class="icon icon-settings"></span>
                    </label> 
                    <input class="form-control" v-model.trim='model.title' id='c-title' name="c-title" placeholder="Името на твоето предложение">
                </div> 
            </div>
        </div>
    </div>  

    <div class="row mb-5">
        <div class="col-12">
            <div class="form-group">
                <h4>Описание на идейното предложение:</h4>
                <textarea class="form-control summernote" name="c-desc"
                          id='c-desc' 
                          v-model='model.desc' 
                          placeholder="Опишете вашето предложение" rols='4'></textarea> 
            </div>
        </div>
    </div>    


    <div class="row">
        <div class="col-sm-6 col-12 mb-5 add-competition-img">
            <h4>Главна снимка</h4>
            <p>
                Това е снимката, която ще се показва в списъка с идейни проекти. 
                Заедно със снимката на корицата ще се визуализират първи. 
                За да направите добро първо впечатление, подберете и ги оформете внимателно с инструмента за изрязване на снимки.
            </p>  
            <div class="main-img-wrap">
                <img-field :model='imgModel' :f='"image"' ref='image' 
                    :options='imageOptions' 
                    v-on:image-set='uploadImage("image")'></img-field>     
            </div>
        </div>

        <div class="col-sm-6 col-12 mb-5 add-competition-gallery">
            <h4>Галерия</h4>
            <p class="mb-0">
                Визуалното представяне на идейното предложение.
            </p> 
            <dropzone :conf='dzConf' v-on:upload-success="addFile"></dropzone>
        </div>
    </div>

    <div class="row mb-5 competition-gallery">
        <div class="col-12">
            <h4>Качени файлове</h4>

            <loading-div v-if='!filesReady'></loading-div>

            <ul class="list-inline d-flex align-items-center files-view">
                <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                    <span class="icon icon-list"></span>
                </li>

                <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                    <span class="icon icon-grid"></span>
                </li>
            </ul>

            <div v-if='filesReady && !files.length' class="alert alert-info">
                Все още нямате качени файлове. 
            </div>

            <div id="files-holder" :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                <div v-if='filesReady && files.length'>
                    <file-grid :files='files' 
                           :conf='fileConfig'
                           v-on:file-removed='fileRemoved'
                           :info='"Качен от вас"'></file-grid>
                </div>    
            </div>

        </div>
    </div>    

    <div v-if='offer.finished == 0' class="row mb-5">
        <div class="col-12">
            <div class="alert alert-info d-flex align-items-center">
                <span class="icon icon-info mr-3"></span>
                <span>
                    Може да добавяте и редактирате вашето Идейно предложение, докато тече конкурса. С натискане на бутона "Запази" запазвате промените само за вас.
                    Когато сте готов с Идейното предложение, уверете се, че сте качил всички необходими файлове и натиснете бутона "Изпрати".
                </span>
            </div>
        </div>

        <div class="col-12 col-sm-6 text-center mt-2">
            <button @click='updateOffer' class="btn btn-info btn-lg w-100">Запази</button>
        </div>
        <div class="col-12 col-sm-6 text-center mt-2">
            <button @click='offerFinished'
                    v-if='hasTitle && hasImage'
                    class='btn btn-primary btn-lg w-100'>Изпрати </button>

            <div class='alert alert-warning' v-if='!hasImage || !hasTitle'>
                За да завършите предложението, трябва да добавите главна снимка и заглавен текст.
            </div>
        </div>
    </div>

    <div v-if='offer.finished == 1' class="row">
        <div class="col-12 ">
            <div class="alert alert-info d-flex align-items-center">
                <span class="icon icon-check1 mr-2"></span>
                Предложението ви е маркирано като готова.
            </div>
        </div>
    </div>

    
</div>

</template>

<script>
    export default {

        mounted() {
            this.getFiles();

            this.initSummernote();
        },

        created() {

            this.model.id    = this.offer.id;
            this.model.title = this.offer.title;
            this.model.desc  = this.offer.desc;

            this.imgModel.cover  = this.offer.cover;
            this.imgModel.image  = this.offer.image;

            if( this.offer.image ) {
                this.hasImage = true;
            }

            if( this.offer.title ) {
                this.hasTitle = true;
            }

        },

        props : ['offer'],

        data() {
            return {
                isReady : false,

                imgModel : {
                    image : null,
                    cover : null,
                },

                model : {
                    id    : 0,
                    title : '',
                    desc  : '',
                },

                fileTypes : ['image/*'],

                files       : [],
                filesReady  : false,
                grid        : false,

                offerSent : false,
                hasTitle : false,
                hasImage : false,

                dzConf : {
                    id : 'udz',
                    url     : '/system/cmp:upf',
                    params  : {
                        c : this.offer.id
                    }
                },

                fileConfig : {
                    info        : "Качен от вас",
                    lightBoxId  : 'usrf',
                    download    : false,
                    remove      : true,
                    removeUrl   : 'cmp:rmf',
                    edit        : true
                },

                imageOptions : {
                    width        : 545,
                    height       : 450,
                    maxFileSize  : 5000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Изображение',
                    wrapperClass : 'place-img-wrap',
                    imageClass   : "place-image",
                    defaultImage : "/resources/images/transparent.png",
                    thumbnail    : 0.4
                },

                coverOptions : {
                    id           : 'cvr',
                    width        : 1920,
                    height       : 500,
                    maxFileSize  : 5000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Изображение',
                    wrapperClass : 'cover-img-wrap',
                    imageClass   : "cover-image",
                    defaultImage : "/resources/images/cover-transparent.png",
                    thumbnail    : false
                },
            }
        },

        methods : {

            getFiles() {
                var me = this;

                me.ajax.call('cmp:gfs', { c : this.offer.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        me.files = r.data;

                    }

                    me.filesReady = true;

                })
            },

            offerFinished() {
                var me = this;

                if( !confirm('Сигурни ли сте, че искате да маркирате проекта като завършена?') ) {
                    return;
                }

                me.ajax.call('cmp:ofn', { c : this.offer.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        me.offer.finished = 1;

                        $.notify('Проектът ви беше маркирана като готор и може да бъде прегледан','success');
                  
                    }

                })
            },

            fileRemoved( i ) {
                this.files.splice(i,1);
            },

            //Upload a main/cover image with cropper
            uploadImage( field ) {
                var me = this;

                me.ajax.call('cmp:upmi', { c : this.offer.id, f : field, i : this.imgModel[ field ] }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        $.notify("Изображението беше качено успешно","success");

                        if( field == 'image' ) {
                            me.hasImage = true;
                        }

                    }

                })
            },

            addFile( f ) {
                this.files.push( f ); 

                $.notify("Файлът беше качен успешно","success");
            },

            updateOffer() {
                var me = this;

                // me.model.desc = $("#c-desc").val();
                me.model.desc = $('#c-desc').summernote('code');

                if( !this.model.title ) {
                    $.notify('Моля въведете заглавие на предложението','warning');

                    this.navigate("#c-title",300);
                    $("#c-title").focus();

                    return;
                }

                //Apply for work
                me.ajax.call('phs:updo', this.model, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.$parent.offer = Object.assign({}, me.$parent.offer, me.model);
                        me.hasTitle = true;

                        $.notify('Промените ви бяха запазени','success');
                    } 

                })
            }
            
        }

    }
</script>
